import { useContext, useState, useEffect } from 'react'
import { CashBackIcon } from 'src/components/Icons/CashbackIcon'
import { ProductContext } from 'src/components/restructure/product/contexts'
import { formatterPrice } from 'src/sdk/checkout/data/utils/formatterPrice'
import { checkEnviromentIsB2B } from 'src/utils/checkEnviroment'

export function CashbackHighlightSection() {
  const { product, currentSku } = useContext(ProductContext)
  const {
    sellerDefault: { sellerOffer },
  } = currentSku

  const isB2B = checkEnviromentIsB2B()
  const hasCashbackHighlight = product?.flagCashbackHighlight
  const { cashbackValue, cashbackPercentage } = sellerOffer ?? {}

  const [shouldShowAbsoluteValue, setShouldShowAbsoluteValue] = useState(false)

  useEffect(() => {
    setShouldShowAbsoluteValue(
      !!window.dynamicYieldUtils?.cashbackHighlight?.isEnabled
    )
  }, [])

  const absoluteCashbackValue = cashbackValue
    ? formatterPrice(cashbackValue)
    : 0

  if (
    !sellerOffer?.cashback ||
    hasCashbackHighlight ||
    isB2B ||
    !cashbackPercentage
  ) {
    return null
  }

  return (
    <div className="product-page-cashback-highlight-ab-test flex gap-[6px] justify-center items-center bg-restructure-background-primary pt-3 pb-4">
      <CashBackIcon />
      {!shouldShowAbsoluteValue && (
        <p className="text-font-size-2 leading-6 font-medium text-restructure-primary">
          {cashbackPercentage}% de cashback para membro Clube Decathlon
        </p>
      )}
      {shouldShowAbsoluteValue && (
        <p className="text-font-size-3 leading-6 font-medium text-restructure-primary">
          Ganhe{' '}
          <span className="text-[#149B65] font-bold">
            {absoluteCashbackValue}
          </span>{' '}
          de volta nesta compra
        </p>
      )}
    </div>
  )
}
